var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        _vm._b(
          {
            staticClass: "drag-drop",
            attrs: { list: _vm.attributes.values },
            on: {
              change: _vm.save,
              start: function ($event) {
                _vm.drag = true
              },
              end: function ($event) {
                _vm.drag = false
              },
            },
          },
          "draggable",
          _vm.dragOptions,
          false
        ),
        _vm._l(_vm.attributes.values, function (value, i) {
          return _c(
            "div",
            { key: i, staticClass: "drag-drop__item drag-drop__item--sm" },
            [
              _c("span", { staticClass: "drag-drop__handle" }, [
                _c("i", { staticClass: "ak-icon ak-table-row__handle" }, [
                  _vm._v("drag_indicator"),
                ]),
              ]),
              _vm._v("\n            " + _vm._s(value.label) + "\n        "),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.attributes && _vm.attributes.helpText
        ? _c("div", {
            staticClass: "form__help",
            domProps: { innerHTML: _vm._s(_vm.attributes.helpText) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.attributes.hasError
        ? _c("div", { staticClass: "form__error" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.attributes.error) },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-alert" }, [
      _c("span", { staticClass: "path1" }),
      _c("span", { staticClass: "path2" }),
      _c("span", { staticClass: "path3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }